import { CONSTANTS } from 'config/constants';

const { GOOGLE_PLACES_API_KEY } = CONSTANTS;

type MapPoint = { latitude?: number | null; longitude?: number | null };

/** A Google static map centred on the point, with a red marker; '' when the point is unknown. */
export const googleStaticMapUrl = (point: MapPoint | null | undefined, language: string, size = '290x175'): string => {
    if (!point) return '';
    const latitude = point.latitude || '';
    const longitude = point.longitude || '';
    return `https://maps.googleapis.com/maps/api/staticmap?key=${GOOGLE_PLACES_API_KEY}&center=${latitude},${longitude}&zoom=14&size=${size}&maptype=roadmap&markers=color:red%7C${latitude},${longitude}&language=${language}`;
};
